import { Injectable } from '@angular/core';

import { OdometroHorimetroService } from "../../../manutencoes/odometros-horimetros/shared/odometro-horimetro.service";

@Injectable()
export class FormaControleService {

    constructor(
        private _odometroHorimetroService: OdometroHorimetroService
    ) { }

    getFormaControleOdometro() {
        return 2;
    }

    getFormaControleHorimetro() {
        return 3;
    }

    getFormaControleSem() {
        return 1;
    }

    submitOdometroHorimetro(value: any) {
        if (value) {
            value = value.replace(/\D/g, '');
            return Number(value);
        } else {
            return null;
        }
    }

    setOdometroHorimetroToForm(value: any) {
        if (value) {
            value = this._odometroHorimetroService.setMask(value);
        } else {
            value = '';
        }
        return value;
    }

    changeFormaControle(formaControleId: any) {
        let tipoOdometro: number = this.getFormaControleOdometro();

        if (formaControleId === tipoOdometro) {
            return true;
        }

        return false;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/formas-controle/shared/forma-controle.service.ts
 **/